import {Injectable} from "@angular/core";
import {Actions, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {EOsaActions, GetScanning, GetScanningFailure, GetScanningSuccess} from "../../actions/osa/osa.actions";
import {catchError, map, switchMap, withLatestFrom} from "rxjs/operators";
import {OsaService} from "../../services/osa.service";
import {of} from "rxjs";
import {IOsaEvent} from "../../models/osa/osa.interface";
import {Logout} from "../../actions/security/authentication.actions";


@Injectable()
export class OsaScanningEffects {
  Scanning$ = this._actions$.pipe(
    ofType<GetScanning>(EOsaActions.GetScanning),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) =>{
      return this._osaService.getScannings(storeState.authentication.data.accessToken,  storeState.applicationParameters)
        .pipe(
          map(
            result =>{
              const scanningArray:Array<IOsaEvent> = [];
              result['Data'].forEach((item) =>{
                const osaEvent:IOsaEvent = {
                  id: item['scan_id'],
                  date: item['scan_date'],
                  ean: item['ean'],

                  itemId: item['item_id'],
                  itemCode: item['item_code'],
                  itemName: item['item_description'],
                  itemDescription: item['item_description'],

                  siteId: item[''],
                  siteCode: item[''],
                  siteName: item[''],
                  siteDescription: item[''],

                  eventCalcTypeCode: item['event_type_code'],
                  eventCalcTypeName: item['event_type_name'],

                  eventManualTypeCode: item[''],
                  eventManualTypeName: item[''],

                  stockQty: null,

                  lastOrderCode: item['order1_number'],
                  lastOrderDate: item['order1_delivery_date'],
                  lastOrderQy: item['order1_ordered_qty'],

                  userId: item['user_id'],
                  userName: item['user_id'],
                  userLogin: item['user_id']
                };
                scanningArray.push(osaEvent);
              });
              return new GetScanningSuccess(scanningArray);
            }
          ),
          catchError(error => {
            console.log('GetPartners error');
            console.log(error);
              if(error['status']===401) {
                this._store$.dispatch(new Logout());
              }
            return of(new GetScanningFailure());
          }

          )
        );
      }

    )

  );
  constructor(
    private _osaService: OsaService,
    private _actions$: Actions,
    private _store$: Store<IAppState>,
  ) {}

}
